class exports.Controller

    constructor: (@scope, @transitions) ->
        # Do we want to automatically show/hide the preloader
        # during state changes?
        @preload_on_state_change ?= true

        # Timeout ID for alerts
        @_alert_timeout_id = null

        @scope.absolute_errors   = false

        # Message of alert in message writer (if empty then alert is not displayed)
        @scope.alert_message     = ''

        # Type of alert in message writer (determines css class applied. can be success, error, info)
        @scope.alert_type        = ''

        # Details about the alert in message writer (must be an array. dislayed as bullet points below alert_message)
        @scope.alert_details = []

        # Preloader Message (if empty then preloader is not implemented)
        @scope.preloader_message = ''

        # Show preloader message
        @scope.show_preloader    = false

        # Show full page (if false then only sidebar is seen)
        @scope.show_fullpage     = true

        @scope.setAlert          = @setAlert
        @scope.clearAlert        = @clearAlert
        @scope.setPreloadMsg     = @setPreloadMsg
        @scope.getUnsetRows      = @getUnsetRows
        @scope.parseMimeType     = @parseMimeType
        @scope.save              = @save

        @scope.instance = this

        if @preload_on_state_change
            @transitionStart = @transitions.onStart {}, ($transition) =>
                if @scope.preloader_message
                    @setPreloadState(true)

            @transitionSuccess = @transitions.onSuccess {}, ($transition) =>
                if @scope.preloader_message
                    @setPreloadState(false)

        @scope.$on '$destroy', () =>
            @transitionStart?()
            @transitionSuccess?()


    validate: (event, args) =>
        if typeof @save is 'function'
            @save true


    setPreloadMsg: (msg) =>
        if msg?.length
            @scope.preloader_message = msg
        else
            @scope.preloader_message = ''


    setPreloadState: (show) =>
        @scope.show_preloader = show


    setAlert: (json_status, details = [], timeout = null, force_clear = false) =>
        if json_status?.msg?.length or details.length
            # set the content
            @scope.alert_message = json_status.msg
            @scope.alert_type = json_status.type
            @scope.alert_details = details

            # clear the previous timeout (if set)
            if @_alert_timeout_id?
                clearTimeout(@_alert_timeout_id)
                @_alert_timeout_id = null

            if not timeout?
                # set default timeout value
                if json_status.type in ['success', 'info'] or force_clear
                    # if it's a success message, clear it after 2 seconds
                    timeout = 2000
                else
                    # otherwise just leave it
                    timeout = false

            # `false` means no timeout (message remains indefinitely)
            if timeout isnt false
                # I feel like this should use angular's $timeout, but I don't
                # want to break literally everything by changing the
                # constructor parameters. Should I do that instead?
                @_alert_timeout_id = setTimeout () =>
                    @clearAlert()
                    @scope.$apply()
                , timeout
        else
            @clearAlert()

    clearAlert: () =>
        # clear the content
        @scope.alert_message = ''
        @scope.alert_type = ''
        @scope.alert_details = []

        # doesn't hurt to clear the previous timeout (if set)
        if @_alert_timeout_id?
            clearTimeout(@_alert_timeout_id)
            @_alert_timeout_id = null


    refresh: () ->
        params = $.extend({}, @state.params)
        @state.go(@state.current, params)


    ### Useful functions used lots of places ###

    # creates array with a length equivalent to the length of the past in array/obj minus the given length
    getUnsetRows: (list, length) =>
        # handle objects
        if typeof list isnt 'undefined'
            list = $.map list, (v, k) =>
                return v

            new_length = length - list.length
        else
            new_length = length

        # Ensure that our new array length is not negative
        if new_length >= 0
            return new Array(new_length)
        else
            return new Array(0)


    # Returns Type of given mime (ignores subtype)
    parseMimeType: (mime) =>
        if mime? and mime isnt ''
            pattern = /^(.*?)\//
            mime = mime.match(pattern)[0]
            return mime
        else
            return null


    # TODO: this shouldn't be in the base Controller class, because it's only
    # used in a couple specific contexts
    #
    # uhhhh, yes times 100 to the above comment!
    parseMentions: (text, mentionable) =>
        # Parse and store mentions
        # match on beginningOfLine or whitespace "@NonWhitespace"
        regex = (/(^|\s)@((?:[^\s\.,!;])+)/g)
        match = regex.exec(text)
        new_mentions = []

        # js regex keeps track of cursor location within string when matching
        while match isnt null
            for user in mentionable
                # If the users username is the same as the match and if its not in new_mentions
                if user.username is match[2] and new_mentions.indexOf(user) is -1
                    new_mentions.push user
                    break

            match = regex.exec(text)

        return new_mentions

    loadScopeData: (promise, key) =>
        promise.then (response) =>
            if response?.data?.status?.type is 'success'
                @scope[key] = response.data.data
        return promise
